const REF_KEY = 'peatch-ref-code'

export function captureRefFromUrl(): void {
  try {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('ref')
    if (code && /^[A-Za-z0-9]{4,16}$/.test(code) && !localStorage.getItem(REF_KEY)) {
      localStorage.setItem(REF_KEY, code.toUpperCase())
    }
  } catch {
    // ignore (private mode / disabled storage)
  }
}

export function getStoredRefCode(): string | null {
  try {
    return localStorage.getItem(REF_KEY)
  } catch {
    return null
  }
}

export function clearStoredRefCode(): void {
  try {
    localStorage.removeItem(REF_KEY)
  } catch {
    // ignore
  }
}
